import fetch from 'utils/fetch';

export function fetchProducts() {
  return fetch('/products.json').then(res => res.json());
}

export function fetchProduct(id) {
  return fetch(`/products.json/${id}`).then(res => res.json());
}



// WEBPACK FOOTER //
// ./src/modules/common/api/products.js